import React from 'react';

function BotaoAlertVistoria({ tipoVistoria, onSelect }) {
  const baseBtn = {
    minWidth: '130px',
    width: '100%',
    maxWidth: '160px',
    height: '44px',
    borderRadius: '12px',
    border: '1px solid #3a4252',
    background: '#161b24',
    color: '#dce3f1',
    fontWeight: 700,
    letterSpacing: '0.3px',
    cursor: 'pointer',
    transition: 'all .2s ease',
    boxSizing: 'border-box'
  };

  const activeBtn = {
    background: 'linear-gradient(135deg, #00D594, #00b67f)',
    color: '#062219',
    border: '1px solid #00D594',
    boxShadow: '0 8px 24px rgba(0, 213, 148, .25)'
  };

  return (
    <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap', width: '100%' }}>
        <span style={{ width: '100%', textAlign: 'center', color: '#e5e7eb', fontWeight: 700, fontSize: '15px', marginBottom: '8px' }}>
            Selecione o tipo de vistoria:
        </span>

        <div style={{display:"flex", gap: 10, justifyContent: 'center', flexWrap: 'wrap', width: '100%'}}>
            <button
            type="button"
            onClick={() => onSelect('vistoria_evento')}
            style={{ ...baseBtn, ...(tipoVistoria === 'vistoria_evento' ? activeBtn : {}) }}
            >
                EVENTO
            </button>

            <button
            type="button"
            onClick={() => onSelect('vistoria_cadastro')}
            style={{ ...baseBtn, ...(tipoVistoria === 'vistoria_cadastro' ? activeBtn : {}) }}
            >
                CADASTRO
            </button>
        </div>
    </div>
  );
}

export { BotaoAlertVistoria };
export default BotaoAlertVistoria;